// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumb_container__3riIe","back":"BreadCrumb_back__2n2cF","backText":"BreadCrumb_backText__eupEG"};